import { render, staticRenderFns } from "./TopSportsBar.vue?vue&type=template&id=3d620417&scoped=true"
import script from "./TopSportsBar.vue?vue&type=script&lang=js"
export * from "./TopSportsBar.vue?vue&type=script&lang=js"
import style0 from "./TopSportsBar.vue?vue&type=style&index=0&id=3d620417&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d620417",
  null
  
)

export default component.exports